import { createFont, createTamagui } from "@tamagui/core";
import { createMedia } from "@tamagui/react-native-media-driver";
import { tokens } from "./config/tokens.mjs";
import { typography } from "./themes/default/typography.mjs";
const headingFont = createFont({
    face: {
      500: {
        normal: "ValueSerifProMedium"
      }
    },
    family: "Value Serif Pro",
    lineHeight: {
      large: tokens.size["header.lineHeight.large"].val,
      regular: tokens.size["header.lineHeight.regular"].val
    },
    letterSpacing: {
      large: -tokens.size["header.size.large"].val * 0.02,
      regular: -tokens.size["header.size.regular"].val * 0.02
    },
    size: {
      large: tokens.size["header.size.large"].val,
      regular: tokens.size["header.size.regular"].val
    },
    weight: {
      bold: 500
    }
  }),
  bodyFont = createFont({
    face: {
      400: {
        normal: "MabryProRegular"
      },
      500: {
        normal: "MabryProMedium"
      }
    },
    family: "Mabry Pro",
    size: {
      tiny: tokens.size["text.size.tiny"].val,
      small: tokens.size["text.size.small"].val,
      regular: tokens.size["text.size.regular"].val,
      large: tokens.size["text.size.large"].val,
      xLarge: tokens.size["text.size.xLarge"].val,
      xxLarge: tokens.size["text.size.xxLarge"].val
    },
    letterSpacing: {
      tiny: 0,
      small: 0,
      regular: 0,
      large: 0,
      xLarge: 0,
      xxLarge: 0
    },
    lineHeight: {
      tiny: tokens.size["text.lineHeight.tiny"].val,
      small: tokens.size["text.lineHeight.small"].val,
      regular: tokens.size["text.lineHeight.regular"].val,
      large: tokens.size["text.lineHeight.large"].val,
      xLarge: tokens.size["text.lineHeight.xLarge"].val,
      xxLarge: tokens.size["text.lineHeight.xxLarge"].val
    }
  }),
  config = createTamagui({
    media: createMedia({
      small: {
        minWidth: 480
      },
      medium: {
        minWidth: 768
      },
      large: {
        minWidth: 992
      },
      xlarge: {
        minWidth: 1280
      },
      "2xlarge": {
        minWidth: 1440
      },
      "3xlarge": {
        minWidth: 1920
      }
    }),
    fonts: {
      heading: headingFont,
      body: bodyFont
    },
    settings: {
      webContainerType: "normal",
      allowedStyleValues: "somewhat-strict-web",
      autocompleteSpecificTokens: "except-special"
    },
    cssStyleSeparator: `
`,
    themes: {
      // We need to set a light theme to avoid a tamagui error even though it's not used.
      light: {
        ...typography
      },
      defaultTheme: {
        ...typography
      }
    },
    tokens
  });
export { config };